import React, {useEffect, useState} from 'react';
import "./Admin.css"
import {WorkShopItem} from "./Workshop";
import ReactQuill from "react-quill";
import 'react-image-picker/dist/index.css'

const modules = {
    toolbar: [
        [{header: [1, 2, 3, 4, 5, 6]}],
        ["italic", "underline", "strike", "blockquote"],
        [{list: "ordered"}, {list: "bullet"}],
        ["link"],
    ]
};

const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet"
]
const URL = process.env.NODE_ENV === 'production' ? '/api/' : "http://192.168.1.4:3001/";

async function fetchApi(url: string, data: any, token?: string) {
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    return await (await fetch(`${URL}${url}`, {headers, method: 'POST', body: JSON.stringify(data)})).json();
}

function Admin() {
    const [adminData, setAdminData] = useState<any>({});
    const [editedIndex, setEditedIndex] = useState<Number | null>(null);
    const [validToken, setValidToken] = useState<boolean>(false);
    const [token, setToken] = useState<string>('');
    const [logs, setLogs] = useState<{ login: string, password: string }>({login: '', password: ''});
    const [file, setFile] = useState<File | null>();

    function fetchDataFromApi() {
        let fetchData = async () => {
            let data = await (await fetch(URL + 'data')).json();
            setAdminData(data)
        }
        fetchData()
    }

    useEffect(() => {
        if (validToken) {
            fetchDataFromApi();
        }

    }, [token, validToken]);

    useEffect(() => {
        if (!validToken && token) {
            let headers = new Headers();
            headers.set('Authorization', `Bearer ${token}`);
            fetch(URL + 'auth/auth', {headers}).then(e => {
                e.text().then(w => {
                    if (w == 'ok') {
                        setValidToken(true)
                    }
                })
            })
        }
    }, [token])
    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        if (storedToken) {
            setToken(storedToken)
        }
    }, []);
    return (
        <>
            {!validToken && <div>
                <label htmlFor={"login"}>Login</label>
                <input onChange={({target: {value}}) => {
                    setLogs({...logs, login: value})
                }} value={logs.login} type={"text"} id="login"/>
                <label htmlFor={"login"}>Mot de passe</label>
                <input onChange={({target: {value}}) => {
                    setLogs({...logs, password: value})
                }} value={logs.password} type={"password"} id="password"/>
                <button onClick={() => {
                    fetchApi('auth/login', logs).then(e => {
                        if (e?.access_token) {
                            setToken(e?.access_token)
                            localStorage.setItem("token", e?.access_token)
                        }
                    });

                }}> Envoyer
                </button>
            </div>}
            {validToken && <div className="Admin">
                <h1>Admin Atelier Test,( change uniquement cette page !) </h1>
                {adminData?.workshops?.map((e: any, i: Number) => <span
                        key={`ws${i}`}
                    >
                    {editedIndex !== i && <><WorkShopItem
                            subtitle={e.subtitle}
                            title={e.subtitle}
                            description={e.description}
                            image={{url: `${URL}images/${e.image.url}`, title: e.image.title}}
                        />
                            <button title={"edit"} onClick={() => {
                                setEditedIndex(i)
                            }}>Modifier
                            </button>
                        </> ||
                        <EditWorkshop data={e} images={adminData.images} onSave={(edited) => {
                            fetchApi('data/editWorkshop', {...edited, idx: editedIndex}, token).then(e => {
                                setEditedIndex(null)
                                fetchDataFromApi()

                            })
                            // setAdminData({
                            //     ...adminData,
                            //     workshops: adminData.workshops.map((e: any, x: Number) => x === i ? edited : e)
                            // })
                            // setEditedIndex(null)

                        }}/>
                    }

            </span>
                )}
                <br/>
                <br/>

                <br/>
                Choisir une image a ajouter au serveur
                <input type="file" onChange={(e) => {

                    const file = e?.target?.files?.[0];
                    if (file) {
                        setFile(file);
                    }
                }
                }/>
                <button onClick={() => {
                    if (file) {

                        var data = new FormData()
                        data.append('image', file)
                        // data.append('title', 'hubot')


                        let headers = new Headers();
                        headers.set('Authorization', `Bearer ${token}`);
                        fetch(`${URL}upload/image`, {
                            method: 'POST',
                            body: data,
                            headers,
                        }).then(async (e) => {
                            fetchDataFromApi()
                            setFile(null)
                        })
                    }

                }} disabled={!file}> Ajouter l'image
                </button>
            </div>
            }  </>);
}

function EditWorkshop({data, onSave, images}: { data: any, onSave: (e: any) => void, images: any[] }) {
    const [edited, setEdited] = useState(data);
    return <>
        <div>

            title
            <ReactQuill
                className="quill"
                // theme="snow"
                modules={modules}
                formats={formats}
                placeholder={"Titre"}
                value={edited.title}
                onChange={(e) => {
                    if (e !== edited.title) {
                        setEdited({...edited, title: e})

                    }
                }}
            />
        </div>
        <div>
            Sous titre
            <ReactQuill
                // theme="snow"
                className="quill"
                modules={modules}
                formats={formats}
                placeholder={"Sous titre"}
                value={edited.subtitle}
                onChange={(e) => {
                    if (e !== edited.subtitle) {
                        setEdited({...edited, subtitle: e})

                    }
                }
                }
            />
        </div>
        <div>

            Sescription
            <ReactQuill
                className="quill"
                // theme="snow"
                modules={modules}
                formats={formats}
                placeholder={"Description"}
                value={edited.description}
                onChange={(e) => {
                    if (e !== edited.description) {
                        setEdited({...edited, description: e})

                    }
                }}
            />
        </div>
        <div>

            Image

            <div style={{
                display: "grid",
                gridTemplateColumns: " repeat(auto-fill, minmax(75px, 1fr))",
                gap: "5px",
                flexDirection: "column",
                width: `80%`,
                height: "200px",
                overflowX: "hidden",
                overflowY: "scroll",
                border: 'solid 1px grey'
            }}>
                {images?.map((item: any, index: number) => <img onClick={() => {
                    setEdited({...edited, image: images.find(j => j.title === item.title)})
                }} style={{
                    border: edited.image.title === item.title ? 'solid 2px #2daaa7' : '',
                    objectFit: 'cover',
                    margin: "5px",
                    width: "75px",
                    display: 'flex'
                }} alt={item.title} src={`${URL}images/${item.url}`}
                                                                key={item.title}/>)}
            </div>
            <img src={`${URL}images/${edited.image.url}`} width={'10%'}/>


        </div>
        <button onClick={() => {
            onSave(edited)
        }}>Sauvegarder
        </button>

    </>
        ;
}

export default Admin;
